module.exports = __webpack_public_path__ + "img/cc-logo-full.c6215ce.svg";